import { render, staticRenderFns } from "./WidgetSonPageForm.vue?vue&type=template&id=05170603"
import script from "./WidgetSonPageForm.vue?vue&type=script&lang=js"
export * from "./WidgetSonPageForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetSonPageForm.vue?vue&type=style&index=0&id=05170603&prod&lang=css"
import style1 from "./WidgetSonPageForm.vue?vue&type=style&index=1&id=05170603&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports